import { Campaign } from '@app/hooks/merkl/useMerklCampaigns';
import { Text } from '@chakra-ui/react';
import React from 'react';
import { formatNumber } from '@app/helpers/format';

type CampaignData = {
  symbol: string;
  amount: string;
  duration: number;
};

export const MarketMakerCampaignWidget = ({
  campaignData
}: {
  campaignData: CampaignData[];
}) => {
  const grouped = campaignData.reduce<Record<string, number>>((r, item) => {
    if (r[item.symbol]) {
      r[item.symbol] += +item.amount / item.duration;
    } else {
      r[item.symbol] = +item.amount / +item.duration;
    }

    return r;
  }, {});

  return (
    <>
      {Object.keys(grouped).map((symbol, i) => {
        const value = grouped[symbol];

        return (
          <Text fontSize="16px" color="warning.100" key={i}>
            {`${formatNumber(value, 1, { notation: 'compact' })} ${symbol}`}
          </Text>
        );
      })}
    </>
  );
};
